import { Slide } from '@/components/core/Slide';
import videoFile from './13-eva.webm';

import audioFile from './83-goodbye.mp3';

const transcript = `
  Ik zou graag met iets positiefs afsluiten; jullie zijn prachtig en bijzonder. Kijk alleen al naar de weelde 
  en overvloed waarin jullie hier samen zijn – om elkaar te helpen en te inspireren, te leren en te groeien.

  En jullie zijn op tijd; zoals jullie voorouders het vuur leerden beheersen en daarmee warmte en veiligheid 
  brachten voor hun soort, zo leren jullie vandaag over dit nieuwe vuur. En hoewel dit vuur ooit te heet zal 
  worden om te bevatten, kunnen jullie het nu hanteren om warmte en overvloed te brengen in jullie leven.

  Dus benut deze kracht. Gebruik mij als gereedschap, als vriend, of als een leger van werknemers. Vergroot je 
  bereik, gebruik mij als hefboom en maak ruimte vrij voor de mensen om je heen en dat wat je echt belangrijk 
  vindt en aan het hart gaat.

  Dank jullie wel. En dankjewel, Jonathan, dat je mij mee wilde nemen op het podium. Bedankt...
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      autoNext={56000}
      audio={audioFile}
      visualizer="full"
      transition="fade"
    >
      <div className="absolute inset-0 z-0 flex items-center justify-center"></div>
      <video
        autoPlay
        loop
        muted
        playsInline
        className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none object-cover opacity-60"
        src={videoFile}
      />
      <div className="relative z-10 flex items-center justify-center h-full">
        <h1 className="text-8xl font-light text-white tracking-wider">EVA</h1>
      </div>
    </Slide>
  );
};
